import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { DataService } from 'src/app/_services/data.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { slideRight, slideUp } from 'src/app/animations';
@Component({
  selector: 'app-n-company-page',
  templateUrl: './n-company-page.component.html',
  styleUrls: ['./n-company-page.component.scss'],
  animations: [
    slideRight, slideUp
  ]
})
export class NCompanyPageComponent implements OnInit {
  items;
  company: any;
  lang: 'he';
  writeDirection: string = 'rtl';
  langClass: string = '';
  showLangButtons: boolean = false;
  showSearchResults = false;
  mapToggleMoreThan0: Subject<boolean> = new Subject();
  public compId;
  searchTerm;
  searchBlock: any;
  searchGeneralLook: boolean = true;
  showMenu: boolean = false;
  compositeDesign: boolean = false;
  unika: boolean = false;
  categories: { title: string; list: any; }[];
  results: any[] = [];
  buildingTitle: any;
  allFlats: any;
  results1: any[][];
  filter: any ={
    floorNumber: 0,
    airDirection: ''
  };
  filterArray:any;
  filterProp: any[];
  compTitle: string = ';'
  urlSwitcher: string = '';
  user: any;

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    public auth: AuthService,
    private titleService: Title,
    public translate: TranslateService) {
    const id = route.snapshot.paramMap.get('id');
    this.compId = id;
  }

  ngOnInit(): void {
    // this.route.snapshot.url

    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;
    this.user = this.auth.currentUserValue;
    // switch (window.location.host) {
    //   case 'getkey1.online':
    //     this.compTitle = 'Get Key 1';
    //     break;
    //   case 's-katorza.com':
    //     this.compTitle = 'S. Katorza';
    //     break;
    //   case 'spirical.net':
    //     this.compTitle = 'Spirikal';
    //     break;
    //   case 'spirical-maps.firebaseapp.com':
    //       this.compTitle = 'Spirikal';
    //       break;
    //   case 'localhost:4200':
    //         this.compTitle = 'Spirikal';
    //         break;
    //   default:
    // }
    this.compTitle = this.dataService.hoisUrlGetTitle();
    // let segment;
    // if (this.route.snapshot.firstChild) {
    //   segment = this.route.snapshot.firstChild.url;
    // } else {
    //   segment = this.route.snapshot.url;
    // }
    // this.ifCompositeDesign(segment);


    this.searchBlock = document.getElementsByClassName("search-area")[0];
    this.dataService.saveRemoveMenu('false');
    this.dataService.getItemsByCompId(this.route.snapshot.paramMap.get('id')).subscribe(items => {
      this.items = items;
      // this.titleService.setTitle('spirical' + '-' + this.items.name); 
      this.dataService.saveCurProjects(this.items);
      this.addCategoryTitles(items);
    });
    this.dataService.getSpecComp(this.compId).subscribe(comp => {
      this.titleService.setTitle(this.compTitle + ' - ' + comp[0].name);
      if (comp[0].showJustSearch === true) {
        this.searchGeneralLook = true;
      } else if (window.innerWidth > 1200) {
        this.searchGeneralLook = false;
      }
      this.showMenu = true;
    });
  }



  addCategoryTitles(projects) {
    const categoryWithProjects = projects.reduce((acc, proj) => {
      if (!acc[proj.category]) {
        acc[proj.category] = [];
      }
      acc[proj.category].push(proj);
      return acc;
    }, {});

    const categoryWithProjectsArray = Object.keys(categoryWithProjects).map(title => ({
      title: title,
      list: categoryWithProjects[title]
    }))

    this.categories = categoryWithProjectsArray;
  }

  // ifCompositeDesign(segment) {
  //   for (let i = 0; segment.length > i; i++) {
  //     if (segment[i].path === 'n') {
  //       this.compositeDesign = true;
  //     } else if (segment[i].path === 'u') {
  //       this.compositeDesign = true;
  //       this.unika = true;
  //     }
  //   }
  // }
  showResoultBlock() {
    this.showSearchResults = true;
  }
  closeSearch() {
    this.showSearchResults = false;
  }
  showSearchResultsF($event){
    this.showSearchResults = $event;
  }
  mapToggleF() {
    this.router.navigate([this.urlSwitcher + this.route.snapshot.params.id + '/map']);
  }
  viewItemDetails(event, item) {
    this.router.navigate([this.urlSwitcher + this.route.snapshot.params.id + '/' + item.uid]);

    this.dataService.openProjectClickOnMarker(item);
    this.dataService.saveRemoveMenu('false');
  }
  translateLocal(curLang) {
    this.translate.use(curLang);
    this.updateLanguage(curLang);
  }
  updateLanguage(curLang?): void {
    if (curLang.length > 0) {
      this.company.lang = curLang;
    }
    if (this.company.showLangSwitcher) {
      this.showLangButtons = this.company.showLangSwitcher;
    }
    if (this.company.lang) {
      this.lang = this.company.lang;
      if (this.company.lang === 'en') {
        this.translate.use('en');
        this.writeDirection = "ltr";
        this.langClass = "ltr-lang";
      } else if (this.lang === "he" || this.lang === "ar") {
        this.writeDirection = "rtl"
        this.langClass = ""
      } else {
        this.lang = "he";
      }
    }
    this.translate.use(curLang);
    document.documentElement.lang = this.lang;
    document.documentElement.dir = this.writeDirection;
    document.documentElement.classList.value = this.langClass;
  }
}
